import React from "react";

export default function Banner({ children, className = "", altBG }) {
  return (
    <section
      className={`bg-sunny-top-left bg-cover-image bg-rounded ${className}`}
    >
      <div className="container">
        <div className="row align-items-center justify-content-between">
          {children}
        </div>
      </div>
    </section>
  );
}
